"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    subtitle2StrongerClassNames: function() {
        return subtitle2StrongerClassNames;
    },
    useSubtitle2StrongerStyles: function() {
        return useSubtitle2StrongerStyles;
    }
});
const _react = require("@griffel/react");
const subtitle2StrongerClassNames = {
    root: 'fui-Subtitle2Stronger'
};
const useSubtitle2StrongerStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "flh3ekv",
        Bg96gwp: "faaz57k"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".flh3ekv{font-weight:var(--fontWeightBold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}"
    ]
});
